/**
 * KC CoPilot Design System — canonical token values.
 * Single source of truth. `npm run tokens` regenerates tokens.css from this file.
 *
 * Layer 1 (primitives): raw values, mirror Savills UDS Figma variable names.
 * Layer 2 (semantic):   role-based aliases — the ONLY layer app CSS should use.
 * Layer 3 (component):  per-component knobs.
 *
 * See DESIGN_SYSTEM.md (repo root) for the architecture.
 */

const primitives = {
  color: {
    // Savills UDS — system/steel-gray/*
    "steel-gray-100": "#111111",
    "steel-gray-80": "#33373b",
    "steel-gray-70": "#555b62",
    "steel-gray-60": "#79828c",
    "steel-gray-20": "#e3e6e8",
    "steel-gray-10": "#f2f3f5",
    // Savills UDS — system/blue, system/red, brand
    "blue-60": "#0063ce",
    "blue-10": "#e6f1fc",
    "red-60": "#ce181e",
    "green-70": "#015801",
    "green-10": "#ebf5ee",
    "yellow-brand": "#ffdf00",
    white: "#ffffff",
    black: "#000000",
  },
  font: {
    "family-base": '"Gotham", "Montserrat", -apple-system, sans-serif',
    "family-mono": 'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace',
    "size-12": "12px",
    "size-14": "14px",
    "size-16": "16px",
    "size-22": "22px",
    "size-26": "26px",
    "weight-book": "400",
    "weight-medium": "500",
    "weight-bold": "700",
  },
  space: {
    1: "4px",
    2: "8px",
    3: "12px",
    4: "16px",
    5: "20px",
    6: "24px",
    7: "30px",
    8: "40px",
  },
  radius: {
    sm: "8px",
    md: "12px",
    lg: "16px",
    pill: "999px",
  },
  shadow: {
    card: "0 4px 4px rgba(85, 91, 98, 0.08)",
  },
};

const semantic = {
  // Text
  "text-primary": primitives.color["steel-gray-100"],
  "text-secondary": primitives.color["steel-gray-80"],
  "text-muted": primitives.color["steel-gray-70"],
  "text-placeholder": primitives.color["steel-gray-60"],
  "text-on-action": primitives.color.white,
  // Backgrounds
  "bg-surface": primitives.color.white,
  "bg-subtle": primitives.color["steel-gray-10"],
  "bg-user-message": primitives.color["blue-10"],
  "bg-feedback-success": primitives.color["green-10"],
  // Borders
  "border-default": primitives.color["steel-gray-20"],
  // Actions
  "action-primary": primitives.color["blue-60"],
  danger: primitives.color["red-60"],
  success: primitives.color["green-70"],
  "brand-mark": primitives.color["yellow-brand"],
  "focus-ring": primitives.color["blue-60"],
};

const component = {
  "sidebar-width": "300px",
  "input-height-sm": "34px",
  "input-height-md": "44px",
  "button-radius": primitives.radius.sm,
  "card-radius": primitives.radius.md,
};

module.exports = { primitives, semantic, component };
